import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const PesoGramasInput = forwardRef((props, ref) => (
  <InputTemplate {...props} sufixo="g" ref={ref} />
));

export default PesoGramasInput;
